import { isPlainObject } from 'lodash'

export default function registryMiddleware(registry, dispatch) {
    return store => next => action => {
        const { type } = action;

        if (!type) {
            return next(action);
        }

        if (isPlainObject(action) && action.type == "STORE_INJECT") {
            const reducers = action.reducers;

            if (reducers) {
                registry.injectReducers(reducers)
            }

            return
        }

        return next(action)
    }
}
